import { STORED_PROFILE_CAP_FREE } from '@/features/billing-usage';
import { PlanFeature, type AugmentedAccount } from '@/services/auth/types';

// The backend's Flex limit without a stored-profile pack.
export const FLEX_BASE_STORED_PROFILES = 500;

// The backend always sends a positive stored_profiles limit: 500 on Flex, raised by stored-profile
// packs. An expired pack is not enabled. With no live limit, fall back to the free cap.
export function storedProfileLimit(account: AugmentedAccount) {
  const { enabled, limit } = account.planFeatures[PlanFeature.StoredProfiles];
  return !enabled || limit === false || limit <= 0 ? STORED_PROFILE_CAP_FREE : limit;
}
